"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _RelDownloadStats = _interopRequireDefault(require("../model/RelDownloadStats"));
var _RelManifest = _interopRequireDefault(require("../model/RelManifest"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * Watsess
                                                                                                                                                                                                                                                                                                                                                                                               * Watsess API
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * The version of the OpenAPI document: 1.0.0
                                                                                                                                                                                                                                                                                                                                                                                               * Contact: lightimehpq@gmail.com
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
                                                                                                                                                                                                                                                                                                                                                                                               * https://openapi-generator.tech
                                                                                                                                                                                                                                                                                                                                                                                               * Do not edit the class manually.
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               */
/**
* Release service.
* @module api/ReleaseApi
* @version 1.0.0
*/
var ReleaseApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new ReleaseApi. 
  * @alias module:api/ReleaseApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ReleaseApi(apiClient) {
    _classCallCheck(this, ReleaseApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Callback function to receive the result of the getRelease operation.
   * @callback module:api/ReleaseApi~getReleaseCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RelManifest} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * 获取 latest 版本信息
   * 获取 latest 版本信息
   * @param {module:api/ReleaseApi~getReleaseCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RelManifest}
   */
  _createClass(ReleaseApi, [{
    key: "getRelease",
    value: function getRelease(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _RelManifest["default"];
      return this.apiClient.callApi('/release/latest', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getReleaseAsset operation.
     * @callback module:api/ReleaseApi~getReleaseAssetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取发布的应用
     * 获取发布的应用
     * @param {String} o release asset os, \"Windows/Linux/Darwin/Docker/Harmony/Android/Iphone/Ipad/OpenWRT\"
     * @param {String} t release type, \"App/Service\"
     * @param {String} a release asset architecture
     * @param {Object} opts Optional parameters
     * @param {String} opts.v release version(e.g 1.2.3), default is \"latest\"
     * @param {Boolean} opts.i require installer? Default is true
     * @param {module:api/ReleaseApi~getReleaseAssetCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "getReleaseAsset",
    value: function getReleaseAsset(o, t, a, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'o' is set
      if (o === undefined || o === null) {
        throw new Error("Missing the required parameter 'o' when calling getReleaseAsset");
      }
      // verify the required parameter 't' is set
      if (t === undefined || t === null) {
        throw new Error("Missing the required parameter 't' when calling getReleaseAsset");
      }
      // verify the required parameter 'a' is set
      if (a === undefined || a === null) {
        throw new Error("Missing the required parameter 'a' when calling getReleaseAsset");
      }
      var pathParams = {};
      var queryParams = {
        'v': opts['v'],
        'o': o,
        't': t,
        'i': opts['i'],
        'a': a
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/release/asset', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getReleaseStats operation.
     * @callback module:api/ReleaseApi~getReleaseStatsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RelDownloadStats} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取发布应用的下载统计数据
     * 获取发布应用的下载统计数据
     * @param {module:api/ReleaseApi~getReleaseStatsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RelDownloadStats}
     */
  }, {
    key: "getReleaseStats",
    value: function getReleaseStats(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _RelDownloadStats["default"];
      return this.apiClient.callApi('/release/stats/dl', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the postRelease operation.
     * @callback module:api/ReleaseApi~postReleaseCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 更新最新版本发布信息
     * 更新最新版本发布信息
     * @param {module:api/ReleaseApi~postReleaseCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "postRelease",
    value: function postRelease(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/release/latest', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);
  return ReleaseApi;
}();